import { createContext, useCallback, useMemo } from 'react';

import { useAuth } from '@/contexts/AuthProvider';
import { PERMISSION_TYPE } from '@/enums';
import { useGetRoles } from '@/services';
import { ChildrenProps, RoleType } from '@/types';

type RolesAndPermissionContextType = {
  isAllowedTo: (permissions: string[]) => boolean;
  roles: RoleType[] | [];
};

const initialContext: RolesAndPermissionContextType = {
  isAllowedTo: () => false,
  roles: []
};

export const RolesAndPermissionContext =
  createContext<RolesAndPermissionContextType>(initialContext);

type RolesAndPermissionProviderProps = ChildrenProps;

export const RolesAndPermissionProvider = ({ children }: RolesAndPermissionProviderProps) => {
  const { user: currentUser, hasAllPermissions } = useAuth();
  const { data: rolesResponse } = useGetRoles(currentUser);
  const roles = useMemo(() => rolesResponse?.data ?? [], [rolesResponse?.data]);

  // TODO: This should be refactored and removed once all components that use it are refactored
  const isAllowedTo = useCallback(
    (requiredPermissions: string[]) => hasAllPermissions(requiredPermissions as PERMISSION_TYPE[]),
    [hasAllPermissions]
  );

  const contextValue = useMemo(
    () => ({
      isAllowedTo,
      roles
    }),
    [isAllowedTo, roles]
  );

  return (
    <RolesAndPermissionContext.Provider value={contextValue}>
      {children}
    </RolesAndPermissionContext.Provider>
  );
};
